import { isEmpty } from 'lodash-es';
import { WIDGET_TYPES } from '../../constants';
import { useGamesFeed } from '../../store/selectors';
import { useCasinoSettings } from '../useCasinoSettings';

export const useGeneralCollectionsInfoForFiltering = ({
  casinoType,
  selectedProviderId,
  selectedCategoryId
}) => {
  const { collectionFeed: collectionsFeedName } = useCasinoSettings(casinoType);

  const collectionsFeed = useGamesFeed(collectionsFeedName) || {};

  const isCollectionsFeedEmpty = isEmpty(collectionsFeed?.categories?.data);

  const collectionSelectedCategory =
    collectionsFeed?.categories?.data?.[selectedCategoryId];

  const isCollections = !!(
    selectedProviderId === WIDGET_TYPES.COLLECTIONS &&
    collectionSelectedCategory
  );

  const collectionsNameTranslationKey =
    collectionSelectedCategory?.title ||
    collectionSelectedCategory?.nameTranslationKey;

  return {
    isCollections,
    collectionsNameTranslationKey,
    isCollectionsFeedEmpty,
    isSelectedProviderIsCollections:
      selectedProviderId === WIDGET_TYPES.COLLECTIONS
  };
};
